import messages from '~/constants/localizations/teamStats';
import { Schema } from './index.d';

export const NHL_PREGAME_OFFENSIVE: Schema[] = [
  {
    key: 'goals_per_game',
    meta_key: 'goals_per_game_rank',
    label: 'Goals',
    localized_label: messages.hockey.goals_per_game,
  },
  {
    key: 'shots_on_goal_per_game',
    meta_key: 'shots_on_goal_per_game_rank',
    label: 'Shots On Goal',
    localized_label: messages.hockey.shots_on_goal_per_game,
  },
  {
    key: 'power_play_percentage',
    meta_key: 'power_play_percentage_rank',
    label: 'Power Play (%)',
    localized_label: messages.hockey.power_play_percentage,
  },
  {
    key: 'faceoff_win_percentage',
    meta_key: 'faceoff_win_percentage_rank',
    label: 'Faceoffs (%)',
    localized_label: messages.hockey.faceoff_win_percentage,
  },
  {
    key: 'team_shooting_percentage',
    meta_key: 'team_shooting_percentage_rank',
    label: 'Shooting (%)',
    localized_label: messages.hockey.team_shooting_percentage,
  },
];

export const NHL_PREGAME_DEFENSIVE: Schema[] = [
  {
    key: 'goals_allowed_per_game',
    meta_key: 'goals_allowed_per_game_rank',
    label: 'Goals Allowed',
    localized_label: messages.hockey.goals_allowed_per_game,
  },
  {
    key: 'shots_on_goal_allowed_per_game',
    meta_key: 'shots_on_goal_allowed_per_game_rank',
    label: 'SOG Allowed',
    localized_label: messages.hockey.shots_on_goal_allowed_per_game,
  },
  {
    key: 'penalty_minutes_per_game',
    meta_key: 'penalty_minutes_per_game_rank',
    label: 'Penalty Minutes',
    localized_label: messages.hockey.penalty_minutes_per_game,
  },
  {
    key: 'penalty_kill_percentage',
    meta_key: 'penalty_kill_percentage_rank',
    label: 'Penalty Kill (%)',
    localized_label: messages.hockey.penalty_kill_percentage,
  },
];

export const NHL: Schema[] = [
  {
    key: 'faceoff_winning_percentage',
    label: 'Faceoffs (%)',
    localized_label: messages.hockey.faceoff_winning_percentage,
  },
  {
    key: 'power_play_opportunities',
    label: 'Power Plays',
    localized_label: messages.hockey.power_play_opportunities,
  },
  {
    key: 'hits',
    label: 'Hits',
    localized_label: messages.hockey.hits,
  },
  {
    key: 'shots',
    label: 'Shots on Goal',
    localized_label: messages.hockey.shots,
  },
];
